import { ThemeUICSSObject } from 'theme-ui';

export enum LAYOUT_VARIANTS {
  container = 'container',
  header = 'header',
  navbar = 'navbar',
  page = 'page',
  form = 'form',
  root = 'root',
}

export const layouts: Record<LAYOUT_VARIANTS, ThemeUICSSObject> = {
  [LAYOUT_VARIANTS.header]: {
    maxWidth: 'container',
    padding: 4,
  },
  [LAYOUT_VARIANTS.navbar]: {
    maxWidth: 'page',
  },
  [LAYOUT_VARIANTS.page]: {
    maxWidth: 'page',
    marginX: 'auto',
  },
  [LAYOUT_VARIANTS.container]: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'container',
    paddingX: 'page',
  },
  [LAYOUT_VARIANTS.form]: {
    maxWidth: 'form',
  },
  [LAYOUT_VARIANTS.root]: {
    minHeight: '100vh',
    maxWidth: 'full',
  },
};
